<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="breadcrumbs-container breadcrumbs-container-edit-company">
          <v-row style="justify-content: center; text-align: center">
            <h1>{{ companyData?.name }}</h1>
          </v-row>

          <v-row class="breadcrumbs" style="justify-content: center">
            <v-breadcrumbs :items="items" class="pl-0">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                  {{ item.text.toUpperCase() }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-row>
        </div>

        <CompanyDataForm
          v-if="companyData"
          ref="companyDataForm"
          :editingCompany="true"
          forCompany="0"
          :companyData="companyData"
          style="width: 70%; margin: auto" />
      </v-col>
    </v-row>

    <v-col class="d-flex mt-10" style="justify-content: space-around">
      <v-btn color="primary" @click="save">
        <v-icon>mdi-content-save</v-icon>
        {{ $t('general.form.save') }}
      </v-btn>

      <v-btn color="red" @click="goBack">
        <v-icon class="white--text">mdi-exit-to-app</v-icon>
        <span class="white--text">{{ $t('general.form.exit') }}</span>
      </v-btn>
    </v-col>

    <ErrorDialog
      :isActive="errorDialog"
      v-bind:tittleText="$t('general.dialog.error.title')"
      :messageText="errorText"
      v-bind:acceptButtonText="$t('general.dialog.error.accept_button')"
      v-on:accept-dialog="errorDialog = false" />
  </v-container>
</template>

<script>
import router from '../../../../plugins/router/index';
import CompanyDataForm from '../../../../components/forms/companyDataForm/companyDataForm.vue';
import ErrorDialog from '../../../../components/errorDialog.vue';

import { getCompany, modifyCompanyByAdmin } from '../../../../viewModels/adminViewModel';

import { ModifyCompanyException } from '../../../../server/petitions/companies/modifyCompanyByAdmin';

export default {
  components: {
    CompanyDataForm,
    ErrorDialog,
  },

  data: () => ({
    companyData: null,
    errorDialog: false,
    errorText: '',
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '../../../dashboard/temperatures',
      },
      {
        text: 'Empresas',
        disabled: false,
        href: '/admin/companies',
      },
      {
        text: 'Empresa',
        disabled: true,
        href: '/admin/companies/edit',
      },
    ],
  }),

  async mounted() {
    try {
      const companyId = this.$route.params.companyId;

      if (!companyId) {
        throw new Error('Missing companyId in route params');
      }

      this.companyData = await getCompany(companyId);
    } catch (e) {
      console.error(e);
      this.errorText = this.$t('general.error.unexpected_error');
      this.errorDialog = true;
    }
  },

  methods: {
    async save() {
      try {
        const form = this.$refs.companyDataForm;
        if (!form || !form.validate()) return;

        await modifyCompanyByAdmin(
          this.companyData._id,
          form.companyName,
          form.companyCIF,
          form.companyPhone,
          form.companyEmail,
          form.companyNotes,
        );

        this.goBack();
      } catch (e) {
        switch (e.code) {
          case ModifyCompanyException.incorrectParameters:
            this.errorText = this.$t('general.error.incorrect_parameters');
            break;
          case ModifyCompanyException.unknownCompany:
            this.errorText = this.$t('company.delete.error.unknown_company');
            break;
          case ModifyCompanyException.nameAlreadyInCompany:
            this.errorText = this.$t('company.add_modify.name_already_in_company');
            break;
          case ModifyCompanyException.cifAlreadyInCompany:
            this.errorText = this.$t('company.add_modify.cif_already_in_company');
            break;
          default:
            this.errorText = this.$t('general.error.unexpected_error');
        }

        console.error(e);
        this.errorDialog = true;
      }
    },

    goBack() {
      router.push({ name: 'companies' });
    },
  },
};
</script>
